import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const PlaidAccessTokenAccountSchema = z
    .object({
        accountId: z.string(),
        name: z.string(),
        mask: z.string(),
        legalName: z.string(),
    })
    .strict();

export class PlaidAccessTokenAccount extends FromSchema(PlaidAccessTokenAccountSchema) {
    accountId: string;
    name: string;
    mask: string;
    legalName: string;
}
